import React, { useCallback } from "react";
import { RadioGroup } from "@clds/radio";
import t from "common/i18n";
import { ColorPalette } from "@cld/color-picker";
import { COLOR_OPTIONS, COLOR_OPTIONS_RAW, COLORS_MAP, COLOR_TYPES_OPTIONS, COLOR_TYPE_TONES } from "../../data/consts";
import { useFilterParams, useSearchParams } from "../../selectors";
import { SectionBox, InlineFieldLayoutCustomized, RadioLabel, ColorPaletteContainer } from "./Filters.styles";


export default ({ handleSearch }) => {
	const { color, colorType } = useFilterParams();
	const { searchPhrase } = useSearchParams();

	const disabled = !searchPhrase;

	const options = COLOR_TYPES_OPTIONS.map((item) => ({
		value: item,
		label: t(`unsplash.filters.color_types.${item}`)
	}));

	const handlePaletteChange = useCallback(([colorHex]) => {
		const mappedColor = COLOR_OPTIONS.find((color) => color.hex === colorHex);
		if (!disabled) { // do not perform any action when component is disabled
			handleSearch({
				filters: {
					color: mappedColor?.value === color ? undefined : mappedColor?.value,
					colorType: COLOR_TYPE_TONES,
				}
			});
		}
	}, [handleSearch, color, disabled]);

	const handleOnClick = useCallback((item) => {
		if (!disabled) { // do not perform any action when component is disabled
			handleSearch({
				filters: {
					color: undefined,
					colorType: item.currentTarget.value === colorType ? undefined : item.currentTarget.value
				}
			});
		}
	}, [colorType, disabled, handleSearch]);

	return (<SectionBox data-test="color-section" disabled={disabled}>
		<label>{t("unsplash.filters.colors.label")}</label>
		<RadioGroup name="radio-group" value={colorType} onClick={handleOnClick}>
			{options.map((item) => (
				<InlineFieldLayoutCustomized key={item.value} label={<RadioLabel htmlFor={item.value} data-test={item.value}>{item.label}</RadioLabel>}>
					<RadioGroup.Radio id={item.value} value={item.value} />
				</InlineFieldLayoutCustomized>
			))}
		</RadioGroup>
		<ColorPaletteContainer>
			<ColorPalette
				isCustomizable={false}
				colors={COLOR_OPTIONS_RAW}
				selectedColors={[COLORS_MAP[color]]}
				onChange={handlePaletteChange}
			/>
		</ColorPaletteContainer>
	</SectionBox>);
};
